import React, { useState } from "react";
import "./TextArea.scss";

export default function TextArea({
  label,
  errorMsg = "",
  containerProps = {},
  charLimit,
  charCount,
  setCharCount,
  setDescVal,
  ...inputProps
}) {
  // const charLimit = 5000;
  // const [charcount, setCharCount] = useState(0);
  return (
    <div className="labelled-input" {...containerProps}>
      <span>
        <label htmlFor="labeled-input-field">{label}</label>
        <label style={{ float: "right" }}>
          {charCount}/{charLimit}
        </label>
      </span>

      <div className="input-field">
        <textarea
          rows={8}
          cols={200}
          maxLength={charLimit}
          {...inputProps}
          name={inputProps.name || label.toLowerCase()}
          className={errorMsg ? "error-input" : ""}
          id="labeled-input-field"
          onChange={(e) => {
            setCharCount((prev) => e.target.value.length);
            setDescVal(() => e.target.value);
          }}
          onKeyUp={(e) => {
            if (e.target.value.length > charLimit) {
              e.target.value = e.target.value.substring(0, charLimit);
              setCharCount((prev) => e.target.value.length);
            }
          }}
        />
        <div className="input-field-right-icon">{inputProps.icon}</div>
      </div>
      {errorMsg && <div className="error-message">{errorMsg}</div>}
    </div>
  );
}
